const { commonConfig } = require('@alfa-bank/assr-common-config');
const { getVkScript } = require('./team.cjs');

const getCounters = (url, data) => {
    const { headCounters, bodyCounters, endBodyCounters } = commonConfig.getCounters(url, data);

    return {
        headCounters: [...headCounters, getVkScript(url)],
        bodyCounters,
        endBodyCounters
    };
};

module.exports = { getCounters };
